export default {
  tools: [],
  tool: null,
  message: null,
};
